// test1743
(1743 && 0);
